import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-专业课程",
  "use": "icon-专业课程-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-专业课程\"><path d=\"M423.87456 444.27264h169.30816v40.96h-169.30816z\" fill=\"\" p-id=\"2271\" /><path d=\"M505.58976 840.88832L170.92608 409.6l157.36832-194.99008h360.48896l157.45024 195.09248-340.64384 431.18592zM223.15008 410.112L505.856 774.43072 793.82528 410.0096l-124.6208-154.4192H347.83232l-124.68224 154.5216z\" fill=\"\" p-id=\"2272\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol